import { render, staticRenderFns } from "./usdtTrun.vue?vue&type=template&id=9fd7a876&scoped=true&"
import script from "./usdtTrun.vue?vue&type=script&lang=js&"
export * from "./usdtTrun.vue?vue&type=script&lang=js&"
import style0 from "./usdtTrun.vue?vue&type=style&index=0&id=9fd7a876&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fd7a876",
  null
  
)

export default component.exports